// extracted by mini-css-extract-plugin
export default {"cls1":"PaperLinkElement-cls1___e2f102ee4096808555d","cls2":"PaperLinkElement-cls2___ee17b65320b4b7bd236 PaperLinkElement-cls1___e2f102ee4096808555d"};